import {
  getInvoiceTransformationLimitMessage,
  InvoiceTransformationLimit,
} from '@monetize/types/app';
import { FC } from 'react';
import { MButton, MText, MTooltip } from '../Monetize';

interface InvoiceTransformationAddButtonProps {
  label: string;
  count: number;
  limit: InvoiceTransformationLimit;
  /** Tooltip shown while below the limit. */
  tooltip?: string;
  /** Validation error on the list itself, e.g. saved over the limit. */
  error?: string;
  onClick: () => void;
}

/**
 * "+ Add …" button for a capped list. Disables itself once `count` reaches the
 * limit, explains why in a tooltip, and shows the list's validation error
 * beside it.
 */
export const InvoiceTransformationAddButton: FC<
  InvoiceTransformationAddButtonProps
> = ({ label, count, limit, tooltip, error, onClick }) => {
  const isAtLimit = count >= limit.max;
  const tooltipLabel = isAtLimit
    ? getInvoiceTransformationLimitMessage(limit)
    : tooltip;

  return (
    <>
      <MTooltip
        label={tooltipLabel}
        placement="right"
        isDisabled={!tooltipLabel}
        // A disabled button fires no pointer events, so the tooltip needs a
        // wrapper to hover. Only wrap when disabled to avoid an extra tab stop.
        shouldWrapChildren={isAtLimit}
      >
        <MButton
          variant="tertiary"
          size="sm"
          onClick={onClick}
          isDisabled={isAtLimit}
        >
          {label}
        </MButton>
      </MTooltip>
      {error && (
        <MText fontSize="sm" color="tRed.base">
          {error}
        </MText>
      )}
    </>
  );
};
